import styled from "styled-components";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import AliceCarousel, { Link } from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import { useTranslation } from "react-i18next";
import getImageURL from "../../../../controllers/getImageURL";
import ReactImageZoom from "react-image-zoom";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import AliceCarouselLink from "../../../helperComponents/AliceCarouselLink";
import { useCallback, useState } from "react";
import { Controlled as ControlledZoom } from "react-medium-image-zoom";

const Top = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TopLeft = styled.div`
  font-size: 27px;
  color: var(--accentColor);
`;

const TopRight = styled.div``;

const List = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;

const Image = styled.img`
  width: 560px;
  height: 354px;
  border-radius: 18px;
  /* margin-top: -10px; */
  object-fit: cover;
  /* pointer-events: none; */

  @media (max-width: 900px) {
    width: 100%;
    border-radius: 0;
    height: 300px;
  }
`;

export default function StoreItemImageGalleryItem({ item }) {
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <AliceCarouselLink
      onClick={() => {
        setIsZoomed(!isZoomed);
      }}
    >
      <ControlledZoom isZoomed={isZoomed} onZoomChange={() => {}}>
        <Image
          // alt="That Wanaka Tree, New Zealand by Laura Smetsers"
          src={getImageURL(item)}
          // width="500"
        />
      </ControlledZoom>
    </AliceCarouselLink>
  );
}
